import { ENUM_COMPONENTSHAREDCTA_KIND } from 'src/strapi/queries'
import { CtaModel } from '../types/ctaModel'

type StrapiCta = {
  label: string
  kind: ENUM_COMPONENTSHAREDCTA_KIND
  url?: string | null
  route?: string | null
  action?: string | null
}

export const normalizeCtaFromStrapi = (
  input?: StrapiCta | null,
): CtaModel | null => {
  if (!input?.kind || !input.label) return null

  switch (input.kind) {
    case ENUM_COMPONENTSHAREDCTA_KIND.external_url:
      return input.url
        ? { kind: 'external_url', label: input.label, href: input.url }
        : null
    case ENUM_COMPONENTSHAREDCTA_KIND.internal_url:
      return input.url
        ? { kind: 'internal_url', label: input.label, href: input.url }
        : null
    case ENUM_COMPONENTSHAREDCTA_KIND.app_route:
      return input.route
        ? { kind: 'app_route', label: input.label, route: input.route }
        : null
    case ENUM_COMPONENTSHAREDCTA_KIND.app_action:
      return input.action
        ? {
            kind: 'app_action',
            label: input.label,
            action: input.action as any,
          }
        : null
    default:
      return null
  }
}
